export enum SearchFormType {
  Airports = 'airports',
  Activities = 'activities',
  AviationEvents = 'events',
  FuelPrice = 'fuel'
}
